import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { ThirdPartyPreferences } from '../components/thirdPartyPreferences';

export const getThirdPartyPreferencesRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    preferences: {
      path: `${basePath}/platform/preferences`,
      url: `${baseUrl}/platform/preferences`,
      documentTitle: 'Preferences',
    },
  };
};

export const getThirdPartyPreferencesRoutes = (
  basePath: string,
  baseUrl: string
) => {
  const config = getThirdPartyPreferencesRoutesConfig(basePath, baseUrl);
  return {
    preferences: (
      <Route exact path={config.preferences.path}>
        <Page routeDefinition={config.preferences}>
          <ThirdPartyPreferences />
        </Page>
      </Route>
    ),
  };
};
